module.exports = __webpack_public_path__ + "img/icon1_11.25442d87.png";